import React, { Component } from 'react';

class Loading extends Component {
  render () {
    return (
      <div>
        Cargando
      </div>
    );
  }
}

export default Loading;
